;(function () {
  angular
    .module('contrast.integrations')
    .controller('VSTSIntegrationCtrl', VSTSIntegrationCtrl)

  function VSTSIntegrationCtrl(
    $scope,
    $q,
    $location,
    $routeParams,
    $translate,
    ErrorService,
    VSTSService,
    integrationService,
    UserService,
    ServiceUtils,
    rulesBugtrackerService,
    BugtrackerCredentialsService,
    ApplicationFactory,
    VSTS_PRIORITIES,
    VSTS_UNASSIGNED,
    VSTS_VERSIONS,
    VSTS_BASIC_AUTH_VERSIONS,
    VSTS_DEFAULT_VERSION,
    INTEGRATION_TYPE,
    VULN_STATUS,
    VULN_STATUS_FIXED,
    VULN_STATUS_NOTAPROBLEM,
    VULNERABILITY_SUBSTATUS
  ) {
    'ngInject'

    var vstsId = $routeParams.vstsId
    var allApplications, allRules
    var _allOptionValue = 'All'
    var emptyIntegration = {
      work_item_state: '',
      trace_status: '',
      trace_substatus: undefined
    }
    var defaultField
    var rules = []
    var setDefaultPrioritiesEnabled = true

    var errorOptions = {
      timeOut: 0,
      extendedTimeOut: 0,
      tapToDismiss: false,
      progressBar: false,
      dismissOnTimeout: false,
      dismissOnClick: false,
      dismissButton: true
    }

    angular.extend($scope, {
      errorCode: undefined,
      errorMsgs: [],
      fieldErrors: [],
      integrationPromise: undefined,
      rulesPromise: undefined,
      model: {
        name: '',
        host: '',
        username: '',
        password: '',
        token: '',
        applications: [],
        all_applications: false,
        assignee: undefined,
        issue_type: undefined,
        project: undefined,
        team: undefined,
        area: undefined,
        version: VSTS_DEFAULT_VERSION,

        auto_create_tickets_enabled: false,
        auto_create_tickets_rules: [],
        auto_create_tickets_severities: [],
        auto_create_tickets_all_rules: false,
        exclude_sensitive_info: false,
        send_tags: false,
        integration: false,
        add_prefix_to_issue_title: false,
        integrations: [],
        placeholderURL: 'https://hostname/DefaultCollection'
      },
      hasPreviousCredentials: false,
      allowEditCredentials: false,
      forceNewSetCreation: false,
      applicationsPromise: undefined,
      latestCredentialsPromise: undefined,
      credentialsListPromise: undefined,
      loadPromise: undefined,
      isEdit: false,
      autoCreateTicketsEnabled: false,
      projectsPromise: undefined,
      properties: {
        priorities: []
      },
      showValidConnection: false,
      select: {
        credentials: [],
        applications: [],
        projects: [],
        teams: [],
        areas: [],
        rules: [],
        assignees: [],
        workItemTypes: [],
        work_item_states: [],
        all_trace_status: angular.copy(VULN_STATUS),
        trace_substatus: angular.copy(VULNERABILITY_SUBSTATUS),
        priorities: [],
        versions: VSTS_VERSIONS
      },
      show: {
        basicAuth: false,
        token: true
      },
      settingsPromise: undefined,
      membersPromise: undefined,
      areasPromise: undefined,
      showInvalidConnection: false,
      isUrlTested: false
    })

    angular.extend($scope, {
      cancelCreation: cancelCreation,
      deleteIntegration: deleteIntegration,
      onChangeTraceStatus: onChangeTraceStatus,
      onChangeWorkItemType: onChangeWorkItemType,
      onChangeProject: onChangeProject,
      onChangeTeam: onChangeTeam,
      onChangeVersion: onChangeVersion,
      onApplicationsUpdated: onApplicationsUpdated,
      onApplicationsDeleted: onApplicationsDeleted,
      onRulesUpdated: onRulesUpdated,
      onRulesDeleted: onRulesDeleted,
      onChangeState: onChangeState,
      resetConnection: resetConnection,
      save: save,
      testConnection: testConnection,
      invalidForm: invalidForm,
      isBasicAuth: isBasicAuth,
      enableAutoCreateTickets: enableAutoCreateTickets,
      updateTwoWayIntegration: updateTwoWayIntegration,
      addTwoWayIntegrationRow: addTwoWayIntegrationRow,
      removeTwoWayIntegrationRow: removeTwoWayIntegrationRow,
      getTraceStatusArray: getTraceStatusArray,
      needsSubstatus: needsSubstatus,

      onUserInputChange: onUserInputChange,

      manageCredentials: manageCredentials,
      onChangeCredentials: onChangeCredentials,
      onCredentialsInputChange: onCredentialsInputChange,
      onUrlSelectChange: onUrlSelectChange
    })

    function init() {
      $scope.select.all_trace_status.push(VULN_STATUS_FIXED)

      $scope.applicationsPromise = getApplications()
      $scope.rulesPromise = _getRules()

      $q.all([$scope.applicationsPromise, $scope.rulesPromise]).then(
        function () {
          _populateRulesCombobox()

          if (angular.isDefined(vstsId)) {
            $scope.isEdit = true
            $scope.integrationPromise = getIntegration()

            $q.all([$scope.integrationPromise]).then(function () {
              var selectedApps = _.filter(
                $scope.select.applications,
                function (app) {
                  return _.includes($scope.selected_appids, app.app_id)
                }
              )

              if ($scope.model.all_applications || selectedApps.length === 0) {
                $scope.model.applications = [allApplications]
                $scope.model.all_applications = true
              } else {
                $scope.model.applications = selectedApps
                $scope.model.all_applications = false
              }

              if ($scope.model.auto_create_tickets_enabled) {
                $scope.autoCreateTicketsEnabled = true
                $scope.model.auto_create_tickets_rules =
                  rulesBugtrackerService.buildRules(
                    $scope.model.auto_create_tickets_rules,
                    $scope.model.auto_create_tickets_severities
                  )
                _setAutoCreateTicketsEnabled()
              } else {
                _setDefaultSeveritiesAsRules()
              }
            })
          } else {
            getLatestUsedCredentials()
            _setDefaultSeveritiesAsRules()
          }
        }
      )
    }

    function deleteIntegration() {
      integrationService
        .deleteIntegration($scope.model, INTEGRATION_TYPE.VSTS, vstsId)
        .then(function (deleted) {
          if (deleted) {
            $location.path(UserService.buildUrl('/settings/integration'), true)
          }
        })
    }

    function updateTwoWayIntegration() {
      if ($scope.model.integration) {
        addTwoWayIntegrationRow()
      } else {
        $scope.model.integrations = []
      }
    }

    function addTwoWayIntegrationRow() {
      var newRow = angular.copy(emptyIntegration)
      newRow.work_item_state = $scope.select.work_item_states[0]
      newRow.trace_status = $scope.select.all_trace_status[0].value

      $scope.model.integrations.push(newRow)
    }

    function removeTwoWayIntegrationRow(twoWayIntegration) {
      var idx = $scope.model.integrations.indexOf(twoWayIntegration)
      if (idx > -1) {
        $scope.model.integrations.splice(idx, 1)
      }
    }

    function onApplicationsUpdated() {
      _updateMultiSelect($scope.model.applications)
      $scope.model.all_applications = false
    }

    function onApplicationsDeleted() {
      $scope.model.all_applications = _deleteMultiSelect(
        $scope.model.applications,
        allApplications
      )
    }

    function invalidForm() {
      var invalid =
        $scope.form.name.$invalid ||
        $scope.form.host.$invalid ||
        (angular.isDefined($scope.model.applications) &&
          $scope.model.applications.length === 0) ||
        (angular.isDefined($scope.form.project) &&
          $scope.form.project.$invalid) ||
        (angular.isDefined($scope.form.assignee) &&
          $scope.form.assignee.$invalid) ||
        (angular.isDefined($scope.form.issue_type) &&
          $scope.form.issue_type.$invalid)

      if (!invalid && $scope.show.basicAuth) {
        invalid =
          invalid ||
          $scope.form.username.$invalid ||
          $scope.form.password.$invalid
      } else {
        invalid = invalid || $scope.form.token.$invalid
      }

      if (!invalid && !angular.isUndefined($scope.model.team)) {
        invalid = $scope.form.area.$invalid
      }

      var workItem = $scope.model.issue_type

      if (
        !invalid &&
        workItem &&
        workItem.default_field &&
        $scope.form.priority_critical
      ) {
        invalid =
          invalid ||
          $scope.form.priority_critical.$invalid ||
          $scope.form.priority_high.$invalid ||
          $scope.form.priority_medium.$invalid ||
          $scope.form.priority_low.$invalid ||
          $scope.form.priority_note.$invalid
      }

      if (!invalid && $scope.model.integration) {
        var uniq = $scope.model.integrations
          .map(function (integration) {
            return {
              count: 1,
              name: integration.work_item_state
            }
          })
          .reduce(function (a, b) {
            a[b.name] = (a[b.name] || 0) + b.count
            return a
          }, {})

        var duplicates = Object.keys(uniq).filter(function (a) {
          return uniq[a] > 1
        })

        var invalidSubstatus = _.some(
          $scope.model.integrations,
          function (integration) {
            return (
              needsSubstatus(integration) &&
              angular.isUndefined(integration.trace_substatus)
            )
          }
        )

        invalid = duplicates.length > 0 || invalidSubstatus
      }

      return invalid
    }

    function getIntegration() {
      $scope.testing = true
      $scope.isUrlTested = true
      $scope.showValidConnection = false
      $scope.showInvalidConnection = false

      return VSTSService.getVSTSBugtracker(vstsId)
        .then(function (data) {
          $scope.showValidConnection = true
          $scope.model = VSTSService.buildVSTSBugtracker(data.bugtracker)

          setDefaultPrioritiesEnabled = false

          onChangeVersion(false)

          $scope.properties = VSTSService.buildVSTSProperties(data.bugtracker)

          $scope.selected_appids = data.bugtracker.applications
          $scope.selected_projectId = data.bugtracker.project

          var request = VSTSService.buildVSTSIntegrationTest(
            $scope.model,
            isBasicAuth()
          )

          VSTSService.getExistingVSTSBugtrackerProjects(vstsId, request).then(
            function (projects) {
              _fillProjects(projects)
            }
          )

          if (angular.isDefined(data.integrations)) {
            $scope.model.integration = true

            $scope.model.integrations = data.integrations.map(function (item) {
              var newRow = {
                work_item_state: item.issue_status,
                trace_status: item.trace_status
              }

              if (angular.isDefined(item.trace_substatus)) {
                newRow.trace_substatus = item.trace_substatus
              }
              return newRow
            })
          }
        })
        .catch(function (data) {
          $scope.showInvalidConnection = true

          $scope.errorCode = data.errorCode
          $scope.errorMsgs = data.errorMsgs
        })
        .finally(function () {
          $scope.testing = false
        })
    }

    function getApplications() {
      return ApplicationFactory.getApplications('', false, '', '', false).then(
        function (response) {
          $scope.select.applications = response.data.applications

          var transl = {
            title_allApplications: $translate.instant('title_allApplications')
          }

          allApplications = {
            name:
              transl.title_allApplications +
              ' (' +
              $scope.select.applications.length +
              ')',
            app_id: _allOptionValue
          }

          $scope.select.applications.push(allApplications)

          if (angular.isUndefined(vstsId)) {
            $scope.model.applications.push(allApplications)
            $scope.model.all_applications = true
          }
        },
        ErrorService.processError
      )
    }

    function save() {
      $scope.adding = true

      if (!$scope.model.auto_create_tickets_enabled) {
        $scope.model.auto_create_tickets_rules = []
        $scope.model.auto_create_tickets_severities = []
        $scope.model.auto_create_tickets_all_rules = false
      }

      var request = VSTSService.buildVSTSIntegration(
        $scope.model,
        $scope.properties,
        isBasicAuth()
      )

      if ($scope.model.integration) {
        VSTSService.buildVSTSTwoWayIntegration(
          request,
          $scope.model.integrations
        )
      }

      if ($scope.isEdit) {
        updateIntegration(vstsId, request)
      } else {
        createIntegration(request)
      }
    }

    function createIntegration(request) {
      VSTSService.addVSTSBugtracker(request).finally(function () {
        $scope.adding = false
      })
    }

    function updateIntegration(vstsId, request) {
      VSTSService.editVSTSBugtracker(vstsId, request).finally(function () {
        $scope.adding = false
      })
    }

    function cancelCreation() {
      $scope.model = {
        name: '',
        applications: [],
        host: '',
        password: '',
        all_applications: false,
        assignee: undefined,
        issue_type: undefined,
        project: undefined,
        auto_create_tickets_enabled: false,
        auto_create_tickets_rules: [],
        auto_create_tickets_severities: [],
        auto_create_tickets_all_rules: false,
        integration: false,
        exclude_sensitive_info: false,
        send_tags: false,
        add_prefix_to_issue_title: false,
        integrations: []
      }

      $scope.select = {
        applications: [],
        rules: [],
        projects: [],
        assignees: [],
        workItemTypes: [],

        work_item_states: [],
        all_trace_status: angular.copy(VULN_STATUS),
        trace_substatus: angular.copy(VULNERABILITY_SUBSTATUS),

        priorities: []
      }

      $location.path(UserService.buildUrl('/settings/integration'), true)
    }

    function testConnection() {
      $scope.isUrlTested = true
      $scope.testing = true
      resetConnection()

      $scope.model.host = $scope.model.host.replace(/(\/)$/, '')

      if ($scope.model.credentials && !$scope.model.credentials.id) {
        $scope.forceNewSetCreation = true
        $scope.model.credentialsId = $scope.model.credentials.id
        $scope.model.host = $scope.model.credentials.host
      }

      var request = VSTSService.buildVSTSIntegrationTest(
        $scope.model,
        isBasicAuth()
      )

      var bugtrackerPromise = $scope.isEdit
        ? VSTSService.testExistingVSTSBugtracker(vstsId, request)
        : VSTSService.testVSTSBugtracker(request)

      bugtrackerPromise
        .then(function () {
          $scope.showValidConnection = true

          $scope.projectsPromise = $scope.isEdit
            ? VSTSService.getExistingVSTSBugtrackerProjects(vstsId, request)
            : VSTSService.getVSTSBugtrackerProjects(request)

          $scope.projectsPromise.then(function (projects) {
            $scope.select.projects = projects

            _fillProjects($scope.select.projects)
          })
        })
        .catch(function (data) {
          $scope.showInvalidConnection = true

          $scope.errorCode = data.error_code
          $scope.errorMsgs = data.bugtracker_errors

          if (data.errors) {
            $scope.errorCode = 400
            $scope.fieldErrors = data.errors
          }
        })
        .finally(function () {
          $scope.testing = false
        })
    }

    function onChangeProject(project) {
      $scope.model.project = project

      _fillProjectSettings()
    }

    function onChangeTeam(team) {
      $scope.model.team = team

      var request = VSTSService.buildVSTSIntegrationProjectTeams(
        $scope.model,
        isBasicAuth(),
        $scope.model.project.id,
        $scope.model.team ? $scope.model.team.id : undefined
      )

      $scope.membersPromise = VSTSService.getVSTSBugtrackerTeamMembers(
        request,
        vstsId
      ).then(function (members) {
        $scope.select.assignees = members
        _fillAssignees(members)
      })

      if (angular.isUndefined($scope.model.team)) {
        $scope.model.area = undefined
        return
      }

      $scope.areasPromise = VSTSService.getVSTSBugtrackerTeamAreas(
        request,
        vstsId
      ).then(function (data) {
        _fillTeamAreas(data.areas, data.defaultArea)
      })
    }

    function onChangeWorkItemType(workItem) {
      if (angular.isUndefined(workItem)) {
        return
      }

      $scope.model.issue_type = workItem

      if (workItem.default_field) {
        $scope.select.priorities = workItem.default_field.values
      } else {
        $scope.select.priorities = []
      }

      _fillPrioritiesFields()
      setDefaultPrioritiesEnabled = true

      _fillStates(workItem)
    }

    function onChangeState(item, integration) {
      var array = getTraceStatusArray()
      var exists = _.some(array, function (status) {
        return status.value == integration.trace_status.value
      })
      if (!exists) {
        integration.trace_status = array[0].value
      }
    }

    function onChangeTraceStatus(item, integration) {
      if (!needsSubstatus(integration)) {
        integration.trace_substatus = undefined
      }
    }

    function _fillStates(workItem) {
      $scope.select.work_item_states = workItem.states

      var validStates = workItem.states

      $scope.model.integrations = _.filter(
        $scope.model.integrations,
        function (integration) {
          return _.includes(validStates, integration.work_item_state)
        }
      )

      if ($scope.model.integrations.length == 0) {
        updateTwoWayIntegration()
      }
    }

    function needsSubstatus(integration) {
      return integration.trace_status == VULN_STATUS_NOTAPROBLEM.value
    }

    function getLatestUsedCredentials() {
      BugtrackerCredentialsService.getLatestUsedCredentials(
        INTEGRATION_TYPE.VSTS
      ).then(
        function (response) {
          if (response.data.success) {
            $scope.model.credentialsId = response.data.credentials.id
            $scope.model.credentials = response.data.credentials
            $scope.model.host = response.data.credentials.host
            $scope.hasPreviousCredentials = true
            testConnection()
          }
        },
        function (response) {
          ServiceUtils.handleError(response, errorOptions)
          $scope.hasPreviousCredentials = false
        }
      )
    }

    function manageCredentials() {
      $scope.credentialsListPromise =
        BugtrackerCredentialsService.getCredentialsList(
          INTEGRATION_TYPE.VSTS
        ).then(
          function (response) {
            $scope.select.credentials = response.data.credentialsList
            $scope.credentialsSelect = true

            resetConnection()

            // Init editable fields
            $scope.model.username = $scope.model.credentials.username
            $scope.model.host = $scope.model.credentials.host
            $scope.model.password = ''
          },
          function (response) {
            ServiceUtils.handleError(response)
          }
        )
    }

    function onChangeCredentials() {
      if ($scope.model.credentialsId !== $scope.model.credentials.id) {
        resetConnection()
        $scope.model.credentialsId = $scope.model.credentials.id
        $scope.model.username = $scope.model.credentials.username
        $scope.model.host = $scope.model.credentials.host
      }
      // Update editable fields
      integrationService.updateEditableFields($scope)
    }

    function onCredentialsInputChange() {
      $scope.allowEditCredentials = true
      resetConnection()
    }

    function onUrlSelectChange(select) {
      integrationService.onUrlSelectChange(select)
    }

    function onUserInputChange(keyword, listToUpdate) {
      if (!keyword) {
        return
      }
      var request = VSTSService.buildVSTSIntegrationProjects(
        $scope.model,
        isBasicAuth(),
        $scope.model.project.id
      )

      if (!$scope.allowEditCredentials) {
        request.credentials = undefined
      }
      _getEditors(request, keyword, listToUpdate, vstsId)
    }
    function getTraceStatusArray() {
      return $scope.select.all_trace_status
    }

    function _getEditors(request, keyword, listToUpdate, id) {
      var projectId = C.getObjectIdFromReference($scope.properties.project.ref)
      VSTSService.getVSTSBugtrackerProjects(
        request,
        projectId,
        keyword,
        id
      ).then(function (response) {
        if (response.data && response.data.data.length > 0) {
          $scope.select[listToUpdate] = response.data.data
        } else {
          $scope.select[listToUpdate] = []
        }
      })
    }

    function onChangeVersion(reset) {
      $scope.show.basicAuth = isBasicAuth()
      $scope.show.token = !isBasicAuth()

      if (reset) {
        resetConnection()
      }
    }

    function isBasicAuth() {
      return VSTS_BASIC_AUTH_VERSIONS.indexOf($scope.model.version) !== -1
    }

    function resetConnection() {
      $scope.showValidConnection = false
      $scope.showInvalidConnection = false
      $scope.isUrlTested = false

      $scope.errorCode = undefined
      $scope.errorMsgs = []
    }

    function enableAutoCreateTickets() {
      $scope.model.auto_create_tickets_enabled =
        !$scope.model.auto_create_tickets_enabled
      if ($scope.model.auto_create_tickets_enabled) {
        _setAutoCreateTicketsEnabled()
      }
    }

    function onRulesUpdated() {
      _updateRulesMultiSelect($scope.model.auto_create_tickets_rules)
      $scope.model.auto_create_tickets_all_rules = false
    }

    function onRulesDeleted() {
      $scope.model.auto_create_tickets_all_rules = _deleteMultiSelect(
        $scope.model.auto_create_tickets_rules,
        allRules
      )
    }

    function _updateMultiSelect(array) {
      var index = _.findIndex(array, function (item) {
        return item.app_id === _allOptionValue
      })

      if (index !== -1) {
        array.splice(index, 1)
      }
    }

    function _updateRulesMultiSelect(array) {
      var index = _.findIndex(array, function (item) {
        return item.value === _allOptionValue
      })

      if (index !== -1) {
        array.splice(index, 1)
      }
    }

    function _deleteMultiSelect(array, allOption) {
      if (array.length === 0) {
        array.push(allOption)
        return true
      } else {
        return false
      }
    }

    function _fillProjects(projects) {
      if (projects && projects.length > 0) {
        $scope.select.projects = projects

        if (angular.isUndefined($scope.model.project)) {
          onChangeProject($scope.select.projects[0])
        } else {
          onChangeProject(
            _.find($scope.select.projects, { id: $scope.model.project })
          )
        }
      }
    }

    function _fillProjectTeams(teams) {
      if (teams && teams.length > 0) {
        $scope.select.teams = teams

        if (!angular.isUndefined($scope.model.team)) {
          onChangeTeam(_.find($scope.select.teams, { id: $scope.model.team }))
        }
      }
    }

    function _fillTeamAreas(areas, defaultArea) {
      if (areas && areas.length > 0) {
        $scope.select.areas = areas

        if (angular.isUndefined($scope.model.area)) {
          $scope.model.area = defaultArea
        } else {
          var selectedArea = _.find($scope.select.areas, function (element) {
            return element === $scope.model.area
          })
          $scope.model.area = angular.isUndefined(selectedArea)
            ? defaultArea
            : selectedArea
        }
      }
    }

    function _fillDefaultValues() {
      _fillWorkItemTypes($scope.select.workItemTypes)
    }

    function _fillPrioritiesFields() {
      var workItem = $scope.model.issue_type
      var sameField =
        angular.isDefined(defaultField) &&
        angular.isDefined(workItem.default_field) &&
        defaultField.field.reference_name ===
          workItem.default_field.field.reference_name

      defaultField = workItem.default_field

      if (setDefaultPrioritiesEnabled) {
        if ($scope.select.priorities.length > 0 && workItem.default_field) {
          if (!$scope.properties.priority_critical || !sameField) {
            $scope.properties.priority_critical =
              workItem.default_field.default_severity_values[
                VSTS_PRIORITIES.CRITICAL
              ]
          }
          if (!$scope.properties.priority_high || !sameField) {
            $scope.properties.priority_high =
              workItem.default_field.default_severity_values[
                VSTS_PRIORITIES.HIGH
              ]
          }
          if (!$scope.properties.priority_medium || !sameField) {
            $scope.properties.priority_medium =
              workItem.default_field.default_severity_values[
                VSTS_PRIORITIES.MEDIUM
              ]
          }
          if (!$scope.properties.priority_low || !sameField) {
            $scope.properties.priority_low =
              workItem.default_field.default_severity_values[
                VSTS_PRIORITIES.LOW
              ]
          }
          if (!$scope.properties.priority_note || !sameField) {
            $scope.properties.priority_note =
              workItem.default_field.default_severity_values[
                VSTS_PRIORITIES.NOTE
              ]
          }
        } else {
          $scope.properties.priority_critical = ''
          $scope.properties.priority_high = ''
          $scope.properties.priority_medium = ''
          $scope.properties.priority_low = ''
          $scope.properties.priority_note = ''
        }
      }
    }

    function _fillWorkItemTypes(workItemTypes) {
      if (workItemTypes && workItemTypes.length > 0) {
        $scope.select.workItemTypes = workItemTypes

        if (!$scope.model.issue_type) {
          onChangeWorkItemType($scope.select.workItemTypes[0])
        } else {
          var workItem = _.filter($scope.select.workItemTypes, function (item) {
            return item.type.name === $scope.model.issue_type
          })[0]

          if (angular.isUndefined(workItem)) {
            onChangeWorkItemType($scope.select.workItemTypes[0])
          } else {
            onChangeWorkItemType(workItem)
          }
        }
      }
    }

    function _fillAssignees(assignees) {
      $scope.select.assignees.unshift(VSTS_UNASSIGNED)

      if (assignees && assignees.length > 0) {
        $scope.select.assignees.concat(assignees)

        if (!$scope.model.assignee) {
          $scope.model.assignee = $scope.select.assignees[0]
        } else {
          $scope.model.assignee = _.find($scope.select.assignees, {
            unique_name: $scope.model.assignee
          })
        }
      } else {
        $scope.model.assignee = $scope.select.assignees[0]
      }
    }

    function _fillProjectSettings() {
      var request = VSTSService.buildVSTSIntegrationProjects(
        $scope.model,
        isBasicAuth(),
        $scope.model.project.id
      )

      $scope.settingsPromise = $scope.isEdit
        ? VSTSService.getExisitingVSTSBugtrackerProjectSettings(vstsId, request)
        : VSTSService.getVSTSBugtrackerProjectSettings(request)

      $scope.settingsPromise
        .then(function (settings) {
          $scope.select.workItemTypes = settings.work_item_types

          _fillDefaultValues()
        })
        .catch(ServiceUtils.handleError)

      var teamsPromise = VSTSService.getVSTSBugtrackerProjectTeams(
        request,
        vstsId
      )
      teamsPromise
        .then(function (teams) {
          _fillProjectTeams(teams)
        })
        .catch(ServiceUtils.handleError)
    }

    function _getRules() {
      return rulesBugtrackerService.getRules().then(function (rulesFound) {
        rules = rulesFound
        allRules = {
          name:
            $translate.instant('title_allRules') +
            ' (' +
            rulesFound.length +
            ')',
          value: _allOptionValue
        }
      })
    }

    function _populateRulesCombobox() {
      $scope.select.rules =
        rulesBugtrackerService.buildRulesWithAllSeverities(rules)
    }

    function _setDefaultSeveritiesAsRules() {
      var defaultSeverities = angular.copy(
        rulesBugtrackerService.buildRulesWithDefaultSeverities()
      )

      $scope.model.auto_create_tickets_rules = []
      $scope.model.auto_create_tickets_severities = []
      $scope.model.auto_create_tickets_all_rules = false

      var i
      for (i = 0; i < defaultSeverities.length; i++) {
        $scope.model.auto_create_tickets_rules.push(defaultSeverities[i])
      }
    }

    function _setAutoCreateTicketsEnabled() {
      if ($scope.model.auto_create_tickets_all_rules) {
        _setAutoCreateTicketsEnabledWithAllRules()
      } else {
        _setAutoCreateTicketsEnabledWithCustomizedRules()
      }
    }

    function _setAutoCreateTicketsEnabledWithAllRules() {
      $scope.model.auto_create_tickets_rules = [allRules]
      $scope.model.auto_create_tickets_severities = []
      $scope.model.auto_create_tickets_all_rules = true
    }

    function _setAutoCreateTicketsEnabledWithCustomizedRules() {
      $scope.model = VSTSService.transformToIntegrationView(
        $scope.model,
        $scope.select.rules
      )
    }

    init()
  }
})()
